module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjMDBBNEQ2IiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPkFydGJvYXJkIDEgY29weSA2PC90aXRsZT48cGF0aCBkPSJNMTIsM2E5LDksMCwxLDEtOSw5LDksOSwwLDAsMSw5LTltMC0xQTEwLDEwLDAsMSwwLDIyLDEyLDEwLDEwLDAsMCwwLDEyLDJaIi8+PHBhdGggZD0iTTEyLDE3YS41LjUsMCwwLDEtLjUtLjV2LTZhLjUuNSwwLDAsMSwxLDB2NkEuNS41LDAsMCwxLDEyLDE3WiIvPjxwYXRoIGQ9Ik0xMiw3LjVhLjUuNSwwLDEsMCwuNS41LjUuNSwwLDAsMC0uNS0uNVoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./static/img/status-information-blue.svg
// module id = 838
// module chunks = 1